import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Option } from 'src/app/model/common/option';

@Injectable()
export class LuoghiService {
  constructor(private http: HttpClient) {}

  getLuoghi(): Observable<Option[]> {
    return this.http.get<Option[]>('/assets/mocks/luoghi.json');
  }
}
